import classnames from 'classnames/bind';
import style from './index.module.scss';
import NetProtocol, { Address, DelUserAddress } from '../../../../Net/NetProtocol';
import Common from '../../../../Common/Common';
import { useState } from 'react';
import { HttpNetPost } from '../../../../Net/HttpNetMg';
import TxtValues from '../../../../components/TxtValues';
const className = classnames.bind(style);

interface PropsTarget {
    userad: Address,
    index: number,
}
const AddressItem = (props: PropsTarget)=>{
    const {userad,index} = props;
    const [showall, setshowall] = useState(false);
    const onModify = ()=>{
      Common.Common.ShowAccount = false;
      Common.UserData = {SelectAd:index+1};
    }
    const onShow = ()=>{
      setshowall(!showall);
    }

    const onDelete = async ()=>{
      let useradr: DelUserAddress = new DelUserAddress();
      useradr.account = Common.UserData.account;
      useradr.tyindex = index;
      const resData:NetProtocol = await HttpNetPost("/delcontact", useradr, true);
      if(resData.code === 0){
        let naddress:Address[] = Common.UserData.address;
        naddress.splice(index, 1);
        Common.UserData = {address:naddress};
      }
    }

    return(
        <div className={className('addressinfo')}>
            <div className={className('numtxt')}>
              {`${index+1}.`}
            </div>
            <div className={className('infotxt')}>
              <TxtValues title='fullname: ' values={userad.fullname}/>
              <TxtValues title='phone: ' values={userad.areacode+userad.phonenum}/>
              {showall &&
                <>
                <TxtValues title='country: ' values={userad.country}/>
                <TxtValues title='address: ' values={userad.address}/>
                <TxtValues title='postcodes: ' values={userad.postcodes}/>
                </>
              }
            </div>
            <div className={className('adbutton')}>
              <button onClick={onShow}>ShowAll</button>
              <button onClick={onModify}>Modify</button>
              {showall &&
                <button onClick={onDelete}>Delete</button>
              }
            </div>
        </div>
    )
}

export default AddressItem;